export const ONE_PAGE_LENGTH = 20;
